<script setup lang="ts">
/**
 * Une ligne d'une fonction et son niveau (T5 §C.5) : le texte, puis
 * l'étiquette « Avancé » là où la différence compte, puis, s'il y a lieu, la
 * raison de la matrice en une ligne. Pour l'écran « Option Avancé » et les
 * lots suivants. Le composant ne juge rien : il écrit ce qu'on lui donne.
 */
// ================================
// IMPORTS
// ================================
import { ETIQUETTE_AVANCE } from "@modules/alarmes-v2/acces/acces"

withDefaults(
    defineProps<{
        /** Le texte de la ligne. */
        texte: string
        /** Vrai quand la fonction est de l'option Avancé : l'étiquette s'affiche. */
        avance?: boolean
        /** La raison de la matrice, en une ligne, si la fonction est fermée. */
        raison?: string | null
    }>(),
    { avance: false, raison: null }
)
</script>

<template>
    <!-- ================================ -->
    <!-- COMPOSANT PRINCIPAL -->
    <!-- ================================ -->
    <span
        class="inline-flex max-w-full flex-wrap items-center gap-x-1.5 gap-y-0.5"
        data-test="ligne-niveau"
    >
        <span class="text-sm text-surface-800">{{ texte }}</span>
        <span
            v-if="avance"
            class="inline-flex items-center whitespace-nowrap rounded-full border border-primary-200 bg-primary-50 px-2 text-xs font-semibold text-primary-700"
            data-test="etiquette-avance"
        >
            {{ ETIQUETTE_AVANCE }}
        </span>
        <span
            v-if="raison"
            class="basis-full text-xs text-surface-500"
            data-test="raison"
        >
            {{ raison }}
        </span>
    </span>
</template>
